import { CATEGORIES } from '../../utils/constants';

const { BACKGROUND, REPORT, TAKE_ACTION, PERFORMANCE, ABOUT, TOPIC_IN_FOCUS } = CATEGORIES;

export const DRAWER_OPEN = 300;
export const DRAWER_COLLAPSED = 60;
export const DRAWER_CONTENT_WIDTH = 260;

export const X_DRAWER_OPEN = 0;
export const X_DRAWER_COLLAPSED = -300;

export const OUT_OFFSET = -50;

export const VISIBLE = 1;
export const INVISIBLE = 0;

export const ANIMATION_DURATION = 300;
export const ANIMATION_DURATION_TIME = `${ANIMATION_DURATION}ms`;

export const DOT_SIZE = 19;
export const DOT_POSITION = DOT_SIZE / 2;
export const DOT_RADIUS = 3.5;

export const INTRODUCTION = 'introduction';

export const SECTIONS_ORDER = [
  { index: 1, id: 'global-pfm-performance', category: PERFORMANCE },
  { index: 2, id: 'crisis-budgeting', category: TOPIC_IN_FOCUS },
  { index: 3, id: 'case-studies', category: TOPIC_IN_FOCUS },
  { index: 4, id: 'a-call-to-action', category: TAKE_ACTION },
  { index: 5, id: 'what-is-pefa', category: BACKGROUND },
  { index: 6, id: 'methodology', category: BACKGROUND },
  { index: 7, id: 'gender-responsiveness', category: BACKGROUND },
];

export const CLOSE_ICON = {
  size: {
    height: 11,
    width: 10,
  },
};
